import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { DateUtil } from 'src/app/util/date.util';

@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss'],
})
export class DateComponent implements OnInit {

  @Input() label: string;
  @Input() model: Date;
  @Input() withTime: number = 0; //1 for date-time, 0 for date, -1 for time
  @Output() modelChange = new EventEmitter<Date>();
  @Input() isMandatory: boolean = false;
  @Input() minDate: string = ''; // ✅ Correct format
  @Input() maxDate: string = '';

  @Output() focusOut = new EventEmitter<Date>();
  modelString: string;
  mandatoryError: string = "";


  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.model.currentValue != null) {
      if (changes.model.currentValue == null) {
        if (this.withTime == 0) {
          this.modelString = DateUtil.convertDateToStringDate(new Date);
        } else {
          this.modelString = DateUtil.convertDateToStringDateTime(new Date);
        }
      } else {
        if (this.withTime == 0) {
          this.modelString = DateUtil.convertDateToStringDate(changes.model.currentValue);
        } else {
          this.modelString = DateUtil.convertDateToStringDateTime(changes.model.currentValue);
        }
      }
    }
  }

  ngOnInit() {
    // console.log(this.maxDate)
  }

  onChangeDate() {
    console.log(this.modelString);
    if (!this.withTime) {
      this.model = DateUtil.convertStringToDate(this.modelString);
    } else {
      this.model = DateUtil.convertTimeStringToDate(this.modelString);
    }
    console.log(this.model.toString());
    this.modelChange.emit(this.model);
  }

  onFocusOut() {
    this.focusOut.emit(this.model);
  }


}
